import { React } from "react";

// Shared presentational helpers for the Fleet Finance pages.

// Postgres NUMERIC may arrive as strings ("500.00"); coerce before formatting.
export const money = (n) =>
  n || n === 0
    ? Number(n).toLocaleString(undefined, { minimumFractionDigits: 2 })
    : "--";

const VARIANT_CLASS = {
  success: "ff-badge ff-badge-success",
  danger: "ff-badge ff-badge-danger",
  warning: "ff-badge ff-badge-warning",
  muted: "ff-badge ff-badge-muted",
  info: "ff-badge ff-badge-info",
};

// map a known status/word to a colour variant
const STATUS_VARIANT = {
  posted: "success",
  active: "success",
  pass: "success",
  approved: "success",
  balanced: "success",
  ok: "success",
  commenced: "success",
  yes: "success",
  true: "success",
  fail: "danger",
  failed: "danger",
  impaired: "danger",
  halt_dispatch: "danger",
  terminated: "danger",
  reversed: "danger",
  pending: "warning",
  draft: "warning",
  investigate: "warning",
  returned: "warning",
  na: "muted",
  no: "muted",
  false: "muted",
};

export const StatusBadge = ({ value, variant }) => {
  if (value === null || value === undefined || value === "") return <>-</>;
  const text = String(value);
  const v = variant || STATUS_VARIANT[text.toLowerCase()] || "info";
  return <span className={VARIANT_CLASS[v]}>{text.replace(/_/g, " ")}</span>;
};

// boolean -> Yes/No badge
export const BoolBadge = ({ value, yes = "Yes", no = "No" }) => (
  <span className={value ? VARIANT_CLASS.success : VARIANT_CLASS.muted}>
    {value ? yes : no}
  </span>
);

export const PageHead = ({ title, subtitle, children }) => (
  <div className="ff-page-head">
    <div className="ff-page-head-titles">
      <h2>{title}</h2>
      {subtitle ? <p>{subtitle}</p> : null}
    </div>
    {children ? <div className="ff-page-head-actions">{children}</div> : null}
  </div>
);

export const KpiGrid = ({ items }) => (
  <div className="ff-kpi-grid">
    {items.map((it) => (
      <div className="ff-kpi-card" key={it.label}>
        <span className="ff-kpi-label">{it.label}</span>
        <span className="ff-kpi-value">{it.value}</span>
      </div>
    ))}
  </div>
);
